import axios from "axios";
const envURL = process.env.REACT_APP_BACKEND_URL;
// Se l'URL env punta a un dominio diverso da quello corrente (preview proxy),
// usa same-origin: l'ingress instrada /api al backend sullo stesso dominio.
const sameOrigin = typeof window !== "undefined" && envURL && new URL(envURL).origin !== window.location.origin;
export const BACKEND_URL = sameOrigin ? window.location.origin : envURL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });
export default api;

export const LOGO_URL = "/logo-full.png";
export const LOGO_ICON = "/logo-icon.png";

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Errore imprevisto";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(e => e?.msg || JSON.stringify(e)).join(" · ");
  return String(d);
}

// ---- Marketing attribution (UTM salvati alla prima visita) ----
const UTM_KEY = "ic_attribution";
export function captureAttribution() {
  if (typeof window === "undefined" || localStorage.getItem(UTM_KEY)) return;
  const q = new URLSearchParams(window.location.search);
  const data = {
    utm_source: q.get("utm_source"), utm_medium: q.get("utm_medium"),
    utm_campaign: q.get("utm_campaign"), utm_content: q.get("utm_content"),
    utm_term: q.get("utm_term"),
    landing_page: window.location.pathname, referrer: document.referrer || null,
    first_visit_date: new Date().toISOString(),
  };
  localStorage.setItem(UTM_KEY, JSON.stringify(data));
}
export function getUtm() {
  try { return JSON.parse(localStorage.getItem(UTM_KEY) || "{}"); } catch { return {}; }
}

// ---- Event tracking ----
export async function track(event, data = {}) {
  try { await api.post("/events", { event, data, utm: getUtm() }); } catch { /* no-op */ }
}
